export default function init_toolbar(IconsView, iconsViewCache) {

    IconsView.prototype.renderToolbar = function (toolbar, element, toolbarClass, top, formData) {
        const myself = this;
        // read columns
        const buttons = $('<div class="left"></div>');
        const buttonsRight = $('<div class="right"></div>');

        // Fixed tools
        if (top) {
            buttonsRight.append(myself.renderToolbarControl({
                name: 'nextView',
                action: 'setView',
                view: 'next',
                label: "Mode d'affichage",
                icon: 'file-type-img-raw',
            }));

            buttonsRight.append(myself.renderToolbarControl({
                type: 'zoom',
            }));

            if (this.dataMode == 'url') {
                buttonsRight.append(myself.renderToolbarControl({
                    name: 'refresh',
                    action: 'reload',
                    label: 'Actualiser',
                    icon: 'arrow-do-refresh',
                }));
            }

            if (this.options && this.options.features && this.options.features.censor) {
                const hasExplicitCensor = toolbar && (
                    toolbar.censor !== undefined ||
                    Object.values(toolbar).some(b => (typeof b === 'object' && (b.name === 'censor' || b.type === 'censor' || b.action === 'toggleCensor')) || b === 'censor')
                );
                if (!hasExplicitCensor) {
                    buttonsRight.append(myself.renderToolbarControl({
                        name: 'censor',
                        type: 'censor',
                        action: 'toggleCensor',
                        label: 'Afficher / Masquer',
                        icon: 'fa-eye',
                    }));
                }
            }
        }

        // Controles
        $.each(toolbar, (indexButton, button) => {
            if (typeof button === 'string') {
                const actionFound = (myself.actions && myself.actions[button]) || (myself.options.actions && myself.options.actions[button]);
                if (actionFound) {
                    toolbar[indexButton] = button = actionFound;
                } else {
                    delete toolbar[indexButton];
                    button = null;
                }
            }

            if (button) {
                const buttonOutput = myself.renderToolbarControl(button);

                // Append
                if (button.align == 'left') {
                    buttons.append(buttonOutput);
                    buttons.append(' ');
                } else {
                    buttonsRight.append(' ');
                    buttonsRight.append(buttonOutput);
                }
            }
        });

        // Hook
        this.buttonsBar = $('<div class="' + toolbarClass + ' ' + ((top) ? 'iv__toolbar--top' : 'iv__toolbar--bottom') + '"></div>');
        this.buttonsBar.append(buttons);
        this.buttonsBar.append(buttonsRight);
        this.buttonsBar.append('<div class="clear"></div>');

        const toolHook = element.parent().parent().parent().find('.iv__toolhook');
        if (toolHook.length) {
            myself.onUnload(toolHook);
            toolHook.html('');
            toolHook.prepend(this.buttonsBar);
        } else if (top) {
            element.prepend(this.buttonsBar);
        } else {
            element.append(this.buttonsBar);
        }

        // Button Click
        this.buttonsBar.find('button').click(function (event) {
            const button = $(this);
            const toolbar = $(button).closest('.iv__toolbar');
            const plugin = toolbar.data('plugin');
            const grid = plugin.element;
            const icons = grid.find('.iv__item--selected');
            grid.data('plugin').action(button.data('action'), grid);
            event.preventDefault();
        });
        this.buttonsBar.data('plugin', this)


        // restore values
        let inputs = this.buttonsBar.find('input, textarea, select');
        inputs.each(function() {
            let name = $(this).attr('name');
            // je veux vérifier si une valeur est défini dans formData
            if (formData[name]) {
                $(this).val(formData[name]);
            }
        })

        // apply filter
        myself.applyFilter(false, this.buttonsBar);
    }


    IconsView.prototype.renderToolbarControl = function (button) {
        const myself = this;

        const buttonClass = [];
        var buttonIcon = (button.item) ? iconImg(button.item) + ' ' : '';
        if (button.style) buttonClass.push('action--' + button.style);
        else buttonClass.push('action--default');
        if (button.require) buttonClass.push('require-' + button.require);

        // Filter Input
        if (button.type == 'filter') {
            var buttonOutput = $(button.input);
            buttonOutput.data('action', button);
            let buttonOutputInput = buttonOutput.add(buttonOutput.find('select, input, textarea'));
            let buttonOutputInputName = buttonOutputInput.attr('name');
            buttonOutputInput.addClass('filter');
            buttonOutputInput.data('field', button.field);
            buttonOutputInput.data('keepNull', (button.keepNull) ? 1 : 0);
            buttonOutputInput.data('queryNull', (button.queryNull) ? 1 : 0);
            buttonOutputInput.data('like', (button.like) ? 1 : 0);
            const currentVal = this.filters[buttonOutputInput.attr('name')];
            if (currentVal) buttonOutput.val(currentVal.value);
            buttonOutputInput.change(() => {
                myself.applyFilter();
            });
            let filterDebounceTimer = null;
            buttonOutputInput.on('input keyup', () => {
                clearTimeout(filterDebounceTimer);
                filterDebounceTimer = setTimeout(() => {
                    myself.applyFilter();
                }, 150);
            });
            myself.reloadInput = true;
            if (button.label) {
                const buttonLabel = $('<label for="' + buttonOutputInputName + '" class="tool-label">' + button.label + ' : </label>');
                buttonOutput = [buttonLabel, buttonOutput];
            }
        }

        // label
        else if (button.type == 'label') {
            var buttonIcon = myself.renderIconImage('small', button.icon) + ' &nbsp;';
            var buttonOutput = $('<label>' + ((button.icon) ? buttonIcon : '') + button.label + '</label>');
        }

        // zoom
        else if (button.type == 'zoom') {
            const activeView = (typeof myself.getActiveView === 'function') ? myself.getActiveView() : null;
            const zoomLimits = (activeView && typeof activeView.getZoomLimits === 'function')
                ? activeView.getZoomLimits()
                : { enabled: false, min: 16, max: 256 };
            const zoomMin = zoomLimits.min || 16;
            const zoomMax = zoomLimits.max || 256;
            const zoomEnabled = !!zoomLimits.enabled;
            if (zoomEnabled) {
                var buttonOutput = $('<input class="iv__zoom" id="iv__zoom--'+this.uid+'" type="range" min="' + zoomMin + '" max="' + zoomMax + '" step="16" style="width: 200px;">');
                buttonOutput.change(function () {
                    myself.setIconSize($(this).val(), null, 1);
                });
                buttonOutput.on('input', function () {
                    $(this).trigger('change');
                });
            }
        }

        // menu input
        else if (button.type == 'menu') {
            const buttonIconHtml = button.icon ? myself.renderIconImage('small', button.icon) : '';
            var buttonOutput = $('<button class="' + buttonClass.join(' ') + ' ' + ((button.icon) ? 'action' : '') + '">' + ((button.icon) ? buttonIconHtml : button.label) + '</button>');
            buttonOutput.data('action', button);

            buttonOutput.click(function (event) {
                const grid = myself.element;

                const processItems = (items) => {
                    const result = [];
                    $.each(items, (index, item) => {
                        if (typeof item === 'string') {
                            if (myself.options.actions && myself.options.actions[item]) {
                                item = myself.options.actions[item];
                            } else if (item === '-') {
                                result.push('-');
                                return;
                            } else {
                                return;
                            }
                        }

                        if (item) {
                            const menuItem = {
                                name: item.label,
                                icon: item.icon,
                                callback: () => {
                                    myself.action(item, grid);
                                },
                            };
                            if (item.items) {
                                menuItem.items = processItems(item.items);
                            }
                            result.push(menuItem);
                        }
                    });
                    return result;
                };

                const menuItems = processItems(button.items);

                if (menuItems.length > 0) {
                    myself.createMenu(menuItems, grid);
                }
                event.stopPropagation();
                event.preventDefault();
            });
        }

        // Search input
        else if (button.type == 'search') {
            const placeholder = button.placeholder || button.label || 'Rechercher...';
            const searchInput = $('<input type="search" class="iv__toolbar-search form-control input-sm" placeholder="' + placeholder + '">');
            if (button.width) searchInput.css('width', button.width);
            let searchDebounceTimer = null;
            searchInput.on('input keyup search', function () {
                clearTimeout(searchDebounceTimer);
                const query = $(this).val();
                searchDebounceTimer = setTimeout(() => {
                    myself.search(query);
                }, 150);
            });
            var buttonOutput = $('<div class="iv__toolbar-search-wrap"></div>');
            if (button.icon !== false) {
                buttonOutput.append(myself.renderIconImage('small', button.icon || 'fa-search') + ' ');
            }
            buttonOutput.append(searchInput);
        }

        // View switch
        else if (button.type == 'viewSwitch') {
            const modes = myself.getAllowedModes() || (myself.template && myself.template.view && myself.template.view.modes) || ['table', 'mosaic', 'list', 'icons', 'thumbnails', 'tree', 'summary', 'calendar'];
            const viewIcons = {
                'table': 'table',
                'mosaic': 'grid',
                'list': 'list',
                'icons': 'picture',
                'thumbnails': 'photo',
                'tree': 'folder-tree',
                'summary': 'file-text',
                'cards': 'id-card',
                'card': 'id-card',
                'calendar': 'calendar',
                'kanban': 'columns',
                'timeline': 'clock',
                'map': 'map-marker',
            };
            const group = $('<div class="btn-group iv__view-switch"></div>');
            $.each(modes, (i, mode) => {
                const isActive = (myself.view === mode) ? ' active' : '';
                const btn = $('<button type="button" class="btn btn-default btn-sm' + isActive + '" title="' + mode + '">' + myself.renderIconImage('small', viewIcons[mode] || 'file-type-img-raw') + '</button>');
                btn.click((e) => {
                    e.preventDefault();
                    myself.action({ action: 'setView', view: mode }, myself.element);
                });
                group.append(btn);
            });
            var buttonOutput = group;
        }

        // Separator
        else if (button.type == 'separator') {
            var buttonOutput = $('<span class="iv__toolbar-separator"></span>');
        }

        // Count
        else if (button.type == 'count') {
            const label = button.label || '';
            const countBadge = $('<span class="iv__toolbar-count badge">0</span>');
            var buttonOutput = $('<span class="iv__toolbar-count-wrap">' + (label ? '<label class="tool-label">' + label + ' : </label> ' : '') + '</span>').append(countBadge);
            myself.toolbarCountBadge = countBadge;
            myself.updateToolbarCount();
        }

        // Censor
        else if (button.type == 'censor' || button.action == 'toggleCensor' || button.name == 'censor') {
            const isCensored = (myself.isCensored !== undefined) ? !!myself.isCensored : true;
            buttonClass.push('iv__toolbar-censor action--censor');
            if (isCensored) buttonClass.push('active is-censored');

            const iconShow = button.iconShow || button.icon || 'fa-eye';
            const iconHide = button.iconHide || 'fa-eye-slash';
            const labelShow = button.labelShow || 'Afficher';
            const labelHide = button.labelHide || 'Masquer';
            const titleShow = button.titleShow || 'Afficher les noms et adresses IP';
            const titleHide = button.titleHide || 'Masquer les noms et adresses IP';

            const currentIcon = isCensored ? iconShow : iconHide;
            const currentLabel = isCensored ? labelShow : labelHide;
            const currentTitle = isCensored ? titleShow : titleHide;

            const buttonIconHtml = myself.renderIconImage('small', currentIcon);
            var buttonOutput = $('<button type="button" class="' + buttonClass.join(' ') + '" title="' + currentTitle + '">' + buttonIconHtml + ' <span class="censor-label">' + currentLabel + '</span></button>');
            buttonOutput.data('action', {
                action: 'toggleCensor',
                name: 'censor',
                iconShow,
                iconHide,
                labelShow,
                labelHide,
                titleShow,
                titleHide,
            });
        }

        // Btn Input
        else {
            var buttonIcon = myself.renderIconImage('small', button.icon);
            var buttonOutput = $('<button class="' + buttonClass.join(' ') + ' ' + ((button.icon) ? 'action' : '') + '" title="' + button.label + '">' + ((button.icon) ? buttonIcon : button.label) + '</button>');
            buttonOutput.data('action', button);
        }

        return buttonOutput;
    }

    IconsView.prototype.updateToolbarCount = function () {
        if (this.toolbarCountBadge && this.toolbarCountBadge.length) {
            const count = (this.data && Array.isArray(this.data)) ? this.data.length : 0;
            this.toolbarCountBadge.text(count);
        }
    };
}
